import request from '@/config/axios'

export interface DistWithdrawVO {
  id: number
  track?: string
  userId: number
  userNickname?: string
  price: number
  fee: number
  type: number
  accountInfo?: string
  status: number
  auditRemark?: string
  createTime?: string
  updateTime?: string
}

export const getDistWithdrawPage = (params: any) =>
  request.get({ url: '/bosscircle/dist-withdraw/page', params })

export const approveDistWithdraw = (id: number) =>
  request.put({ url: '/bosscircle/dist-withdraw/approve', params: { id } })

export const rejectDistWithdraw = (data: { id: number; auditRemark?: string }) =>
  request.put({ url: '/bosscircle/dist-withdraw/reject', data })

export const payoutDistWithdraw = (id: number) =>
  request.put({ url: '/bosscircle/dist-withdraw/payout', params: { id } })
